import { render } from "./DataFiles.vue?vue&type=template&id=770e076a"
import script from "./DataFiles.vue?vue&type=script&lang=js"
export * from "./DataFiles.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Pages/DataFiles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "770e076a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('770e076a', __exports__)) {
    console.log('reload')
    api.reload('770e076a', __exports__)
  }
  
  module.hot.accept("./DataFiles.vue?vue&type=template&id=770e076a", () => {
    console.log('re-render')
    api.rerender('770e076a', render)
  })

}


export default __exports__